var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow-timeline"},[_vm._l((_vm.items),function(element,index){return [_c('div',{key:index,staticClass:"arrow-element",class:element.class,style:(_vm.cssProps)},[_vm._v(" "+_vm._s(element.label)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }